/* eslint-disable no-use-before-define */
import React from 'react';
import InputTypesEnum from '../../../Enums/InputTypesEnum';
import ValidityHelper from '../../../Helpers/ValidityHelper';
import UserItem from './UserItem';
import UserService from '../../../Services/userService';
import RoleService from '../../../Services/roleService';
import stringHelper from '../../../Helpers/stringHelper';

class EditUserWindowDescription extends React.Component {
  static titleForCreate = 'Add New User';
  static titleForEdit = 'Edit User';
  static ComponentName = 'User';
  static itemType = UserItem;
  static serviceFunction = (edited) =>
    edited.IsNewUser ? UserService.CreateUser(edited) : UserService.SaveEditedUser(edited);

  static pagesInGeneralEditWizzard = [
    {
      label: 'General',
      fields: [
        {
          fieldName: 'FirstName',
          label: 'First Name',
          className: 'col-12',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.forRequiredTextField,
        },
        {
          fieldName: 'LastName',
          label: 'Last Name',
          className: 'col-12',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.forRequiredTextField,
        },
        {
          fieldName: 'Email',
          label: 'E-mail',
          className: 'col-12',
          type: InputTypesEnum.Email,
          validityChecker: ValidityHelper.forEmailRequired,
        },
      ],
    },
    {
      label: 'Employment Information',
      fields: [
        {
          fieldName: 'SupervisorId',
          label: 'Supervisor',
          className: 'col-12',
          type: InputTypesEnum.UserSelect,
          validityChecker: ValidityHelper.forRequiredSelectField,
        },
        {
          fieldName: 'OfficialJobTitleId',
          label: 'Job Title',
          className: 'col-12',
          type: InputTypesEnum.OfficialJobTitleLookupItemSelect,
          validityChecker: ValidityHelper.forRequiredSelectField,
        },
        {
          fieldName: 'DepartmentId',
          label: 'Department',
          className: 'col-12',
          type: InputTypesEnum.DepartmentLookupItemSelect,
          validityChecker: ValidityHelper.forRequiredSelectField,
        },
        {
          // CD-5220 (review answer): office is chosen only when CREATING a user. Editing goes through the
          // dedicated Change Office panel, which moves exactly one account — the general edit propagates
          // its fields to every same-email account, so an office here silently relocated the person's
          // other accounts. The backend no longer writes OfficeId on edit either.
          fieldName: 'OfficeId',
          label: 'Office',
          className: 'col-12',
          type: InputTypesEnum.OfficeSelect,
          validityChecker: ValidityHelper.forRequiredSelectField,
          hide: (item) => !item.IsNewUser,
        },
        {
          fieldName: 'ApolloMgrId',
          label: 'Apollo Manager Id',
          className: 'col-12',
          type: InputTypesEnum.NumberWithoutSteppers,
          validityChecker: ValidityHelper.emptyValidityChecker,
        },
        {
          fieldName: 'PosnumberId',
          label: 'TierPos',
          className: 'col-12',
          type: InputTypesEnum.TierLookupItemSelect,
          validityChecker: ValidityHelper.forRequiredSelectField,
        },
        {
          fieldName: 'WorkforceType',
          label: 'Workforce type',
          className: 'col-12',
          type: InputTypesEnum.Select,
          selectvalues: EditUserWindowDescription.getWorkforceTypeOptions(),
          validityChecker: ValidityHelper.forRequiredSelectField,
        },
        {
          fieldName: 'IsOutsourcedEmployee',
          label: 'Is Outsourced Employee',
          className: 'col-12',
          type: InputTypesEnum.OnOff,
        },
      ],
    },
    {
      label: 'Account Settings',
      fields: [
        {
          fieldName: 'IsActive',
          label: 'Is Active?',
          className: 'col-12',
          type: InputTypesEnum.OnOff,
          validityChecker: ValidityHelper.forRequiredBoolField,
        },
        {
          fieldName: 'IncludeSecondaryAccountsInCostCalculation',
          label: 'Include Secondary Accounts In Cost Calculation',
          className: 'col-12',
          type: InputTypesEnum.OnOff,
          validityChecker: ValidityHelper.forRequiredBoolField,
        },
        {
          // CD-5220: only meaningful for contractors, and only Admin/SalesAdmin may set it. `hide` is
          // re-evaluated on every field change, so switching Workforce Type in this panel shows/hides it
          // live. Hidden is enough for the UI; the repository enforces the same rule server-side.
          fieldName: 'IncludeVendorCostInCostCalculation',
          label: 'Include Vendor Cost In Cost Calculation',
          className: 'col-12',
          type: InputTypesEnum.OnOff,
          validityChecker: ValidityHelper.forRequiredBoolField,
          hide: (item) =>
            item.WorkforceType !== 'Contractor' ||
            !RoleService.CheckUserPermission('inputfield', 'useradmin_IncludeVendorCostInCostCalculation'),
        },
        {
          fieldName: 'NotificationsEnabled',
          label: 'Notifications Enabled',
          className: 'col-12',
          type: InputTypesEnum.Bool,
          validityChecker: ValidityHelper.forRequiredBoolField,
        },
        {
          fieldName: 'NoTs',
          label: 'Excluded from Timesheet report',
          className: 'col-12',
          type: InputTypesEnum.Bool,
          validityChecker: ValidityHelper.forRequiredBoolField,
        },
        {
          fieldName: 'TimeZoneOffset',
          label: 'Time Zone',
          className: 'col-12',
          type: InputTypesEnum.TimeZone,
          validityChecker: ValidityHelper.emptyValidityChecker,
        },
        {
          fieldName: 'GroupIds',
          label: 'Groups',
          className: 'col-12',
          type: InputTypesEnum.ActiveGroupMultiChoice,
          validityChecker: ValidityHelper.emptyValidityChecker,
        },
      ],
    },
  ];

  static getWorkforceTypeOptions() {
    return [
      { label: 'Choose one...', value: '', disabled: true },
      { label: 'Employee', value: 'Employee' },
      { label: 'Contractor', value: 'Contractor' },
      { label: 'Student', value: 'Student' },
    ];
  }
}

export default EditUserWindowDescription;
